/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 10/22/15.
 */
'use strict';
angular.module('prism-ui.package').controller('ClipScheduleModalController',
	function ($uibModalInstance, packageObject, defaultFeed, liveFeeds, cancelRecordHandler, RecordResourceFactory) {

		var self = this;
		self.packageObject = packageObject;
		self.currentFeed = defaultFeed;
		self.availableFeeds = liveFeeds.filter(function (feed) {
			return feed.isLive;
		});
		self.recordMap = {};

		self.getRecordForSchedule = function () {
			RecordResourceFactory.get({id: self.schedule.liveRecordId}).$promise.then(function (record) {
				self.record = record;
				self.recordMap[record.id] = record;
			});
		};

		self.selectScheduleForFeed = function () {
			self.schedule = self.packageObject.liveRecordSchedules.filter(function (schedule) {
				return schedule.showLiveFeedId === self.currentFeed.id;
			})[0];

			self.getRecordForSchedule();
		};

		self.onOk = function () {
			$uibModalInstance.close(self.recordMap);
		};

		self.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		self.cancelRecording = function (event) {
			self.schedule.liveRecordOverridden = true;
			cancelRecordHandler(event, self.record);
			self.cancel();
		};

		self.disableOKButton = function () {
			if (self.record && (self.record.status === 'complete' || self.record.status === 'cancelled')) {
				return true;
			}

			if (!(self.schedule.startTime && self.schedule.stopTime)) {
				return true;
			}

			var start = new Date(self.schedule.startTime).getTime();
			var end = new Date(self.schedule.stopTime).getTime();
			var now = new Date().getTime();

			if (self.schedule.liveRecordOverridden && (start <= now || end <= start)) {
				return true;
			}

			return false;
		};

		self.disableStopTimeField = function () {
			return !!self.record && (self.record.status === 'complete' || self.record.status === 'cancelled' ) ||
				!self.schedule.liveRecordOverridden;
		};

		self.disableStartTimeField = function () {
			return !!self.record && self.record.status === 'running' || self.disableStopTimeField();
		};

		self.selectScheduleForFeed();
	});
